import { Card, CardContent } from '@/components/shadcn/card.tsx';
import type { ReactNode } from 'react';

interface CardWrapperProps {
  children: ReactNode;
  customClass?: string;
}

const CardWrapper = ({ children, customClass }: CardWrapperProps) => {
  return (
    <Card className={`${customClass} shadow-none p-0`}>
      <CardContent className='p-2'>{children}</CardContent>
    </Card>
  );
};

export default CardWrapper;
